import AppState from "store/AppState";
import { KpiMetric } from "./KpiConfigTypes";

export const selectKpiConfig = (state: AppState) => state.kpiConfig.config;

export const selectKpiConfigIsLoading = (state: AppState) =>
  state.kpiConfig.isLoading;

export const selectKpiConfigIsLoaded = (state: AppState) =>
  state.kpiConfig.isLoaded;

export const selectKpiConfigError = (state: AppState) => state.kpiConfig.error;

export const selectIsSavingGoal = (state: AppState) =>
  state.kpiConfig.isSavingGoal;

export const selectKpiStoreGoals = (state: AppState) =>
  state.kpiConfig.config?.goals;

export const selectKpiCategories = (state: AppState) =>
  state.kpiConfig.config?.categories || [];

export const selectKpiCategoryById =
  (categoryId: string) => (state: AppState) =>
    state.kpiConfig.config?.categories.find((cat) => cat.id === categoryId);

export const selectKpiMetricsByCategory =
  (categoryId: string) => (state: AppState) =>
    state.kpiConfig.config?.categories.find((cat) => cat.id === categoryId)
      ?.metrics || [];

export const selectKpiMetric =
  (categoryId: string, metricId: string) => (state: AppState) => {
    const category = state.kpiConfig.config?.categories.find(
      (cat) => cat.id === categoryId,
    );
    return category?.metrics.find((metric) => metric.id === metricId);
  };

export const selectKpiMetricsByDisplayType =
  (displayType: "basic" | "pie" | "tree" | "productList") =>
  (state: AppState) => {
    const allMetrics: KpiMetric[] = [];
    state.kpiConfig.config?.categories.forEach((category) => {
      category.metrics.forEach((metric) => {
        if (metric.displayType === displayType) {
          allMetrics.push(metric);
        }
      });
    });
    return allMetrics;
  };

export const selectBasicKpiMetrics = (state: AppState) =>
  selectKpiMetricsByDisplayType("basic")(state);

export const selectPieChartKpiMetrics = (state: AppState) =>
  selectKpiMetricsByDisplayType("pie")(state);

export const selectTreeKpiMetrics = (state: AppState) =>
  selectKpiMetricsByDisplayType("tree")(state);

export const selectProductListKpiMetrics = (state: AppState) =>
  selectKpiMetricsByDisplayType("productList")(state);

export const selectCategoryMetricsByDisplayType =
  (categoryId: string, displayType: "basic" | "pie" | "tree" | "productList") =>
  (state: AppState) => {
    const category = state.kpiConfig.config?.categories.find(
      (cat) => cat.id === categoryId,
    );
    return (
      category?.metrics.filter(
        (metric) => metric.displayType === displayType,
      ) || []
    );
  };

export const selectMetricGoal =
  (categoryId: string, metricId: string) => (state: AppState) => {
    const metric = selectKpiMetric(categoryId, metricId)(state);
    return metric?.goal;
  };
